module.exports = __webpack_public_path__ + "static/img/gaozhongdili4.5d4b965c.jpg";